// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import RuleGroupsCreate from 'pages/ruleGroups/RuleGroupsCreate';

const RuleGroupsList = lazy(() => import('pages/ruleGroups/ruleGroupsList'));

const RuleGroupsRoute = (
  <Route path={routeName.ruleGroups}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULE_GROUPS_VIEW,
            PrivateRouteConst.SELF_RULE_GROUPS_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleGroupsList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_RULE_GROUPS}>
          <Suspense fallback={<Loading />}>
            <RuleGroupsCreate type="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULE_GROUPS_EDIT,
            PrivateRouteConst.SELF_RULE_GROUPS_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleGroupsCreate type="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULE_GROUPS_VIEW,
            PrivateRouteConst.SELF_RULE_GROUPS_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleGroupsCreate type="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RuleGroupsRoute;
